import { IExtendedContext } from '../../types/extendedContext';
import {
  checkPaymentStatusHandler,
  checkPublishAvailabilityHandler,
  getPublishTermsHandler,
  getServicesHandler,
  recheckServicesAvailabilityHandler,
  reloadPublishTermsHandler,
  setElementsVisibilityPresetHandler,
  setOfferHandler,
  setUserHandler,
  switchToSelfMoneySourceHandler,
  switchToMasterMoneySourceHandler,
  resetStateHandler,
  enablePromotionHandler,
} from './methods';

export const getMicrofrontendMethods = (context: IExtendedContext) => [
  {
    path: '/v1/get-state',
    handler: getPublishTermsHandler(context),
  },
  {
    path: '/v1/get-services',
    handler: getServicesHandler(context),
  },
  {
    path: '/v1/check-publish-availability',
    handler: checkPublishAvailabilityHandler(context),
  },
  {
    path: '/v1/set-elements-visibility-preset',
    handler: setElementsVisibilityPresetHandler(context),
  },
  {
    path: '/v1/recheck-services-availability',
    handler: recheckServicesAvailabilityHandler(context),
  },
  {
    path: '/v1/check-payment-status',
    handler: checkPaymentStatusHandler(context),
  },
  {
    path: '/v1/reload-publish-terms',
    handler: reloadPublishTermsHandler(context),
  },
  {
    path: '/v1/switch-to-self-money-source',
    handler: switchToSelfMoneySourceHandler(context),
  },
  {
    path: '/v1/switch-to-master-money-source',
    handler: switchToMasterMoneySourceHandler(context),
  },
  {
    path: '/v1/set-offer',
    handler: setOfferHandler(context),
  },
  {
    path: '/v1/set-user',
    handler: setUserHandler(context),
  },
  {
    path: '/v1/reset-state',
    handler: resetStateHandler(context),
  },
  // Это ручка только для HOM-677. Не использовать в других кейсах
  {
    path: '/v1/enable-promotion-experiment',
    handler: enablePromotionHandler(context),
  },
];
